import api from '../../../core/api/api';

export const facturacionAPI = {
  getFacturacionObrasSociales: async (idObraSocial, fechaDesde) => {
    const fechaFormateada = new Date(fechaDesde).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
    const response = await api.get('/Billing/GetBillingSocialWorkAsync', {
      params: { 
        idObraSocial, 
        fecha: fechaFormateada 
      }
    });
    return response.data;
  },

  calcularImporte: async (data) => {
    const response = await api.post('/Facturacion/CalcularImporte', data);
    return response.data;
  },

  actualizarNroFactura: async (idsTurnos, nroFactura) => {
    const response = await api.put('/Billing/ActualizarNroFactura', { idsTurnos, nroFactura });
    return response.data;
  },

  toggleFacturable: async (idTurno, facturable) => {
    const response = await api.put('/Billing/ToggleFacturable', { idTurno, facturable });
    return response.data;
  },

  recalcularImportesObraSocial: async (idObraSocial, mes, anio) => {
    const response = await api.post('/Billing/RecalcularImportesObraSocial', {
      idObraSocial: parseInt(idObraSocial),
      mes,
      anio
    });
    return response.data;
  },

  facturarObraSocial: async () => {
    const response = await api.get('/Billing/BillingSocialWork');
    return response.data;
  },

  analizarFacturaOS: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/Billing/AnalizarFacturaOS', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  confirmarFacturaOS: async (data) => {
    const response = await api.post('/Billing/ConfirmarFacturaOS', data);
    return response.data;
  },

  obtenerFacturaOS: async (idObraSocial, mes, anio) => {
    const response = await api.get('/Billing/ObtenerFacturaOS', { params: { idObraSocial, mes, anio } });
    return response.data;
  },

  descargarFacturaOS: async (archivo) => {
    const response = await api.get('/Billing/DescargarFacturaOS', {
      params: { archivo },
      responseType: 'blob'
    });
    return response;
  }
};
